module.exports = __webpack_public_path__ + "public/images/icons/case.d8485551f2a4a168643ae2a8463a3eb2.png";